<template>
  <div>
  <div id="fillit-map-container" :data-active="slug" :class="{'is--loading': isLoading}"></div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FillitMap',
  data: () => ({
    payload: null,
    isLoading: true
  }),
  components: {
  },
  computed: {
  },
  props: {
    slug: { type: String, default: null },
    id: { type: String, default: null }
  },
  mounted () {
    this.getData()
  },
  created () {
  },
  methods: {
      getData () {
      var self = this
      // Load Data
        axios
          .get(`https://jellyfish-app-5a7ze.ondigitalocean.app/api/embed/${this.id}`)
          // .get(`http://localhost:3001/api/embed/${this.id}`)
          .then(response => {
              if (response.data) {
                 self.payload = response.data.map
                 self.loadFillitMap()
              }
          })
      },
      loadFillitMap() {
      const self = this

      // Load CSS
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://jellyfish-app-5a7ze.ondigitalocean.app/fillit-map.css";
      document.head.appendChild(link);

      // Load Script
      const script = document.createElement("script");
      script.src = "https://jellyfish-app-5a7ze.ondigitalocean.app/fillit-map.js";
      script.onload = () => {
        if (typeof window.initFillitMap === "function") {
          window.initFillitMap({ data: self.payload })
          self.isLoading = false
        }
      };
      document.head.appendChild(script);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";
#fillit-map-container.is--loading {
  background: url(/assets/button_loader_disabled.svg);
  background-size: 30px;
  background-position: center center;
  background-repeat: no-repeat;
  aspect-ratio: 3 / 2;
}

</style>
